import { Col } from "antd";
import Colors from "assets/Colors";
import styled from "styled-components";

const RightContainer = styled(Col)`
  display: flex;
  justify-content: end;
  gap: 10px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: start;
  }
`;

const NoTables = styled.div`
  align-items: center;
  color: ${Colors.text_secondary};
`;

export default {
  RightContainer,
  NoTables
};
